<template>
  <div class="data-table-condensed">
    <div v-if="this.pagination.rowsPerPage > 10" class="row justify-center">
      <q-pagination
        class="data-table-condensed__pagination"
        v-model="pagination.page"
        :max="numberOfPages"
        :max-pages="5"
        :boundary-numbers="false"
        direction-links
        size="md"
        ellipses
        ripple
        unelevated
        outline
        color="grey-7"
        active-color="secondary"
        active-text-color="secondary"
      />
    </div>
    <q-table
      class="data-table-condensed__table"
      title-class="data-table-condensed__table--title"
      dense
      :title="title"
      :data="rows"
      no-data-label="No Data"
      no-results-label="The filter didn't uncover any results"
      :columns="columns"
      :pagination.sync="pagination"
      hide-pagination
      virtual-scroll
      flat
      style="height: 350px"
      :loading="visible"
      @row-click="getSelectedPlayer"
    >
      <template v-slot:loading>
        <q-inner-loading showing color="secondary" />
      </template>
      <template v-slot:header-cell="props">
        <q-th :props="props">
          {{ props.col.label }}
        </q-th>
      </template>
    </q-table>
  </div>
</template>

<script>
// import PlayerDetails from "@/components/dialog/PlayerDetails.vue";
import { formatCurrency } from "@/utils/formatCurrency";
import { formatTextLabel } from "@/utils/formatText";

export default {
  props: {
    title: String,
    dataset: String,
    timer: Number,
    filter: Object,
  },

  data() {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 10,
      },
      columns: [],
      keys: [],
      rows: [],
      errors: [],
      interval: null,
      dataRefresh: this.$props.timer,
      visible: true,
    };
  },

  methods: {
    async fetchData(siteId, networkId, operatorId) {
      // Dataset name is the store procedure name used to return the results.
      const payload = {
        filterOptions: {
          siteIds: siteId ? [siteId] : [],
          networkId,
          operatorId,
        },
        report: "live-dashboard",
        dataset: this.$props.dataset.replace(/ /g, ""),
      };

      await this.$store
        .dispatch("fetchData", payload)
        .then((response) => {
          if (response.data[0] !== undefined) {
            const keys = Object.keys(response.data[0]);

            this.columns = keys.map((key) => ({
              name: key,
              label: formatTextLabel(key),
              field: key,
              sortable: true,
              align:
                key == "Stake" || key == "GGR" || key == "Deposit"
                  ? "right"
                  : "left",
              format: (value) => {
                if (
                  (key === "PlayerID" && value !== null) ||
                  (key === "Site" && value !== null)
                ) {
                  return `${value}`;
                } else if (key === "GGR" && value !== null) {
                  return formatCurrency(value);
                } else if (value !== null) {
                  return formatCurrency(value);
                } else {
                  return `---`;
                }
              },
            }));
          }
          this.rows = response.data;
          this.visible = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    getSelectedPlayer(evt, row) {
      this.$emit("loadPlayerDetails", {
        id: row.PlayerID,
        site: row.Site,
      });
    },
  },
  watch: {
    filter: function(filterOption) {
      this.fetchData(
        filterOption.siteId,
        filterOption.networkId,
        filterOption.operatorId
      );
      this.visible = true;

      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.fetchData(
          filterOption.siteId,
          filterOption.networkId,
          filterOption.operatorId
        );
      }, this.dataRefresh);
    },
  },
  mounted() {
    this.fetchData(
      this.$store.state.siteFilter.id,
      this.$store.state.networkFilter.id,
      this.$store.state.selectedOperator.id
    );
    this.visible = true;
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      this.fetchData(
        this.$store.state.siteFilter.id,
        this.$store.state.networkFilter.id,
        this.$store.state.selectedOperator.id
      );
    }, this.dataRefresh);
  },
  computed: {
    numberOfPages() {
      return Math.ceil(this.rows.length / this.pagination.rowsPerPage);
    },
  },
  beforeDestroy: function() {
    clearInterval(this.interval);
  },
};
</script>
